import { createAsyncThunk } from '@reduxjs/toolkit';
import createNotification from '../../../../utils/createNotification';
import { ThirdPartyPayoffDocumentKind } from '../../../../models/FlowOfFunds/flow-of-funds.model';

export interface DownloadThirdPartyPayoffSupportingDocumentRequest {
    engagementId: number;
    tableRowId: number;
    documentKind: ThirdPartyPayoffDocumentKind;
}

export const DownloadThirdPartyPayoffSupportingDocument = createAsyncThunk(
    'flowOfFunds/downloadThirdPartyPayoffSupportingDocument',
    async (
        params: DownloadThirdPartyPayoffSupportingDocumentRequest,
        dispatch: any
    ) => {
        const axios = dispatch.getState().core.axios;

        try {
            const response = await axios.get(
                `/api/flowOfFunds/${params.engagementId}/thirdPartyPayoffs/rows/${params.tableRowId}/documents/${params.documentKind}`,
                { responseType: 'blob' }
            );

            if (response.status !== 200) {
                throw new Error('Failed to download the supporting document');
            }

            return response.data as Blob;
        } catch (error) {
            createNotification(
                'Could not download the supporting document.',
                'error'
            );
            throw error;
        }
    }
);
